import React from 'react';
import './HowWeDoIt.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldAlt, faCogs, faBell, faUserCog } from '@fortawesome/free-solid-svg-icons';

const HowWeDoIt = () => {
  
  const handleDownloadClick = () => {
    // Replace with your published Chrome Web Store URL
    window.open('https://chromewebstore.google.com/detail/eq-of-ai/camegpbfdfbonojgidllkmgiebahmged', '_blank');
  };
  const steps = [
    {
      title: 'AI-Driven Data Defense',
      description: (
        <>
         Our cutting-edge extension tracks sensitive data in real-time to ensure your medical, financial, and personal information stays yours.
          <ul>
            <li>🏥 Medical: Your health info is locked down. No more leaks of prescriptions or doctor’s notes.</li>
            <li>💰 Financial: Banking details? Vaulted. Credit card numbers? Invisible to threats.</li>
            <li>👤 Personal: From home addresses to IDs, it’s your life – we make sure it stays private.</li>
          </ul>
        </>
      ),
      icon: <FontAwesomeIcon icon={faShieldAlt} size="3x"/>,
    },
    {
      title: 'Tailored Protection for Each Sector',
      description: (
        <>
          Not all data is created equal. That’s why we craft specialized shields for each industry:
          <ul>
            <li>🔒Medical Fortress: Keep sensitive health data out of the wrong hands.</li>
            <li>📊 Financial Lockdown: Detects even the smallest trace of your financial details.</li>
            <li>🛡️Personal Cloak: Your private life stays private with our system automatically masking identifiers.</li>
          </ul>
        </>
      ),
      icon: <FontAwesomeIcon icon={faCogs} size="3x"/>,
    },
    {
      title: 'Smarter Alerts, Only When You Need Them',
      description: (
        <>
          No spammy alerts. Just the facts. Our system sends you alerts when real threats appear.
          <ul>
            <li>🏥Medical Alert: You’ll get notified instantly if there’s an unusual interaction.</li>
            <li>💰Financial Alert: Got a strange charge? We’ll ping you.</li>
            <li>👤Personal Alert: When your PII is exposed, we’ll cut it off before it becomes a problem.</li>
          </ul>
        </>
      ),
      icon: <FontAwesomeIcon icon={faBell} size="3x"/>,
    },
    {
      title: 'You’re in Control – Always',
      description: (
        <>
          Full control is at your fingertips. Customize what data to monitor and how often to alert.
          <ul>
            <li>🔒 Turn on/off monitoring for specific data.</li>
            <li>📊 Adjust alert frequency and receive summaries when you want.</li>
            <li>🛡️ Set security to full-guard mode or tone it down to your comfort level.</li>
          </ul>
        </>
      ),
      icon: <FontAwesomeIcon icon={faUserCog} size="3x"/>,
    },
  ];

  return (
    <section className="how-we-protect" data-aos="fade-up" id="howWeDoIt" >
      <h2 className="how-we-protect-title"  data-aos="fade-up">🚀 How We Protect What Matters Most</h2>
      <div className="timeline">
        {steps.map((step, index) => (
          <div key={index} className="timeline-step" data-aos="fade-left">
            <div className="timeline-content">
              <div className="timeline-circle">
                {step.icon}
              </div>
              <div className="timeline-text">
                <h3 className="step-title">  </h3>
                <p className="step-description">{step.title}</p>
                <span className="step-details">{step.description}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="f-button">
        <button className="cta"  onClick={handleDownloadClick} >Get Started</button>
      </div>
    </section>
  );
};

export default HowWeDoIt;